import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Missing } from 'models/MissingModel';
import AsyncSelect from 'react-select/async';

const MissingForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.MISSING, Code.Form.Name.MISSING];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [supplierOptions, setSupplierOptions] = Hooks.Form.Options();
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Missing>({});

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.API(Code.File.SUPPLIER, Code.Option.Common.SELECT, setSupplierOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.MISSING_TYPE, Code.Option.Common.SELECT, setTypeOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.MISSING_STATUS, Code.Option.Common.SELECT, setStatusOptions, setError);
   
    //console.log("keyId", keyId);
   
    API.Data.GetByKeyId<Missing>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.missing_active); 
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
      }})
      setLoading(false);
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
    });

    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege} />
          <Control.Tab.Header titles={["Missing Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Date id={Name.Missing.Date} value={formData.missing_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} currentDate={true} />
                <Field.Select id={Name.Common.TypeId} value={formData.type_id} title={Title.Category} options={typeOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true} />
              </Control.Row>
              <Control.Row>
                <Field.FilterSelect id={Name.Supplier.Id} value={formData.supplier_id} title={Title.Supplier} options={supplierOptions} setFormData={setFormData}  require={true} />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Missing.RefNumber} value={formData.missing_ref_number} title={Title.Refno} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
                <Field.Amount id={Name.Missing.Amount} value={formData.missing_amount} title={Title.Amount} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true} />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Missing.Comment} value={formData.missing_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
              <Control.Row>
                <Field.Select id={Name.Common.StatusId} value={formData.status_id} title={Title.Status} options={statusOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
              </Control.Row>
            </Control.Tab.Content>
            
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default MissingForm;